var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"text-center",attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size}},[_c('img',{attrs:{"width":"75%","src":_vm.getCompanyLogoURL(true),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }